export default __webpack_public_path__ + "static/media/431.f99de948.png";